// 移动端点击某个系统
function mobileSystemClick() {
  $('.mobile-body .system-list').on('click', '.system-item', function(event) {
    event.preventDefault();
    $('.mobile-body .system-list .system-item.active').removeClass('active');
    $(this).addClass('active');
    $.message.alert('请在电脑端进行登录');
  });
}
// 头部登录按钮点击
function headerLoginInit() {
  //
  $('.pc-body .header .login-button').on('click', () => {
  });
  // 移动端暂时不支持登录
  $('.mobile-body .header .login-button').on('click', () => {
    $.message.alert('请在电脑端进行登录');
  });
}
// 手机页面头部导航
function mobileHeaderNavInit() {
  $('.header .list-icon').on('click', () => {
    layer.open({
      type: 1,
      content: $('.nav-template').html(),
      anim: false,
      className: 'nav-layer'
    });
  });
}
// 轮播图
function carouselImageInit() {
  $('.carousel-image-container').each(function(index) {
    const className = `carousel-image-index-${index}`;
    $(this).addClass(className);
    const slides = $(this).find('.swiper-slide');
    if (slides.length < 2) {
      $(this).find('.swiper-pagination').hide();
    }
    const swiper = new Swiper(`.${className}`, {
      loop: slides.length > 1,
      autoplay: slides.length > 1,
      pagination: {el: `.${className} .swiper-pagination`}
    });
  });
}
// 返回顶部
function toTopInit() {
  $('.go-top').on('click', () => {
    $('html,body').animate({scrollTop: 0}, 500);
  });
}

// 专家咨询 打开关闭切换
function expertConsultationToggle() {
  var $ec = $('.expert-consultation');
  $ec.on('click', '.consultation-online', () => {
    $ec.toggleClass('show-left');
  }).on('click', '.expert-consultation-close-icon', () => {
    $ec.removeClass('show-left');
  });
}

// 查询码
function searchCode() {
  const $searBtn = $('.search-button');
  $searBtn.click(function() {
    const $input = $(this).parent().find('.search-input');
    const inputValue = $.trim($input.val());
    const codeLength = inputValue.length;
    const traceLink = $input.attr('data-trace');
    const antiLink = $input.attr('data-antifake');
    if (codeLength === 0) {
      $.message.alert('请输入码查询');
    } else if (codeLength === 18 || codeLength === 16 || codeLength === 20) {
      window.location.href = traceLink + '?code=' + inputValue;
    } else if (codeLength === 21 || codeLength === 17 || codeLength === 19) {
      window.location.href = antiLink + '?code=' + inputValue;
    } else {
      $.message.alert('该码不正确!');
    }
  });
}

const init = () => {
  mobileSystemClick();
  headerLoginInit();
  mobileHeaderNavInit();
  carouselImageInit();
  toTopInit();
  expertConsultationToggle();
  searchCode();
};
module.exports = {init};
